import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';
import SignatureInput from '../common/controls/signatureInput';
const ApprovalSignatureField = ({
  onChange,
  onUpload,
  signatureUrl: _signatureUrl = null
}) => _signatureUrl ? /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, null, "Signature"), /*#__PURE__*/React.createElement("div", {
  className: "t-asf-display"
}, /*#__PURE__*/React.createElement("img", {
  alt: "signature",
  src: _signatureUrl,
  style: {
    maxWidth: '100%',
    height: 'auto'
  }
}))) : /*#__PURE__*/React.createElement(SignatureInput, {
  label: "Signature",
  onChange: e => onChange(e ? e.fileName : null),
  onUpload: onUpload
});
ApprovalSignatureField.propTypes = {
  onChange: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  signatureUrl: PropTypes.string
};
export default ApprovalSignatureField;